import { render, staticRenderFns } from "./InitialConfiguration.vue?vue&type=template&id=4463600a&scoped=true&"
import script from "./InitialConfiguration.vue?vue&type=script&lang=ts&"
export * from "./InitialConfiguration.vue?vue&type=script&lang=ts&"
import style0 from "./InitialConfiguration.vue?vue&type=style&index=0&id=4463600a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4463600a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VDivider,VLayout,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})
